import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="fixed bottom-24 right-5 z-40 grid h-12 w-12 place-items-center rounded-xl bg-primary text-white shadow-lift transition hover:bg-secondary sm:bottom-28 sm:right-7" aria-label="Scroll to top">
      <FaArrowUp />
    </button>
  );
}
